import React, { useState } from "react";
import { Pane, todoTheme } from "./styles";
import Modes from "./modes.bs";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core";
import { ThemeProvider } from "styled-components";
import {useTimer} from "./timeutils.bs";
import Timer from "./timer.bs";
export default function PomoTimer() {
  const [theme, setTheme] = useState(todoTheme);
  const [mode, setMode] = useState("Work");
  
  const mins = 60;
  const workTime = 25 * mins;
  const shortBreakTime = 5 * mins;
  const longBreakTime = 10 * mins;

  
  let [workAction, setWorkAction] = React.useState("Pause")
  let [shortBreakAction, setShortBreakAction] = React.useState("Pause")
  let [longBreakAction, setLongBreakAction] = React.useState("Pause")

  let workTimer = useTimer(() => setWorkAction("Done"), workTime)
  let shortBreakTimer = useTimer(() => setShortBreakAction("Done"), shortBreakTime)
  let longBreakTimer = useTimer(() => setLongBreakAction("Done"), longBreakTime)



  let [hidden, setHidden] = useState(false);
  let hide = hidden ? {display: "none"} : {};


  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <Pane style={hide}>
          <Modes mode={mode} setMode={setMode} />
          {mode === "Work" ? <Timer action={workAction} setAction={setWorkAction} timer={workTimer} setTheme={setTheme}/> 
          : 
          mode === "ShortBreak" ? <Timer action={shortBreakAction} setAction={setShortBreakAction} timer={shortBreakTimer} setTheme={setTheme} />
          :
          mode === "LongBreak" ? <Timer action={longBreakAction} setAction={setLongBreakAction} timer={longBreakTimer} setTheme={setTheme}/> : null}
        </Pane>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}

function useSwitchTimers(){

}